import DefaultTemplate from "components/templates/DefaultTemplate";

const Admin = () => {
    return (
        <DefaultTemplate isAdmin={true}>
            <h1 style={{ marginTop: 0, marginBottom: "0.5em" }}>
                ショッピングモール管理
            </h1>
            <div className="moll-edit">
                <a href="/admin/lost-child" className="btn btn-radius-solid">
                    迷子情報編集
                    <i className="fas fa-angle-right fa-position-right"></i>
                </a>
                <a href="/admin/lost-item" className="btn btn-radius-solid">
                    落とし物情報編集
                    <i className="fas fa-angle-right fa-position-right"></i>
                </a>
                <a href="/admin/shop-edit" className="btn btn-radius-solid">
                    導入店舗編集
                    <i className="fas fa-angle-right fa-position-right"></i>
                </a>
                <a href="/admin/home-edit" className="btn btn-radius-solid">
                    お知らせ編集
                </a>
                <a href="/admin/camera" className="btn btn-radius-solid">
                    混雑状況撮影
                </a>
                <a href="/admin/coupon" className="btn btn-radius-solid">
                    特典情報編集
                </a>
            </div>
        </DefaultTemplate>
    );
};

export default Admin;
